/**
 * Scroll reveal for homepage sections
 */
export function initRevealOnScroll() {
  const root = document.querySelector('.mkt') || document.querySelector('.home-page');
  if (!root) return;

  const items = root.querySelectorAll('.mkt-reveal, .home-reveal');
  if (!items.length) return;

  if (!('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
  );

  items.forEach((el) => observer.observe(el));
}
